var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcExchange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3166 4.4363L9.88997 1.14673L9.06329 2.00786L11.2735 4.12963H2.5V5.60408H11.2735L9.06329 7.72587L9.88997 8.587L13.3166 5.29743C13.4338 5.18488 13.5001 5.02938 13.5001 4.86686C13.5001 4.70434 13.4338 4.54885 13.3166 4.4363ZM4.72666 11.8705L6.93686 13.9923L6.11018 14.8534L2.68355 11.5638C2.56631 11.4513 2.50003 11.2958 2.50003 11.1332C2.50003 10.9707 2.56631 10.8152 2.68355 10.7027L6.11018 7.41311L6.93686 8.27424L4.72668 10.396H13.5V11.8705H4.72666Z",
    fill: "#B2B8CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExchange);
export default __webpack_public_path__ + "static/media/ic_exchange.69655a6251e2508b9bb2fa0b0fe824a1.svg";
export { ForwardRef as ReactComponent };